<template>
<div>

<v-dialog max-width="500" v-model="settings.visible" :fullscreen="$vuetify.breakpoint.smAndDown" transition="v-fade-transition" persistent :hide-overlay="false" scrollable>

<div :style="{height: dialogHeight}" class="dialog-container">

    <div class="dialog-header">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
            <v-spacer />
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                <v-icon v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="showCopyToOffices">
                        <v-list-item-title>Copy to Offices</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="clientToClipboard">
                        <v-list-item-title>Copy to Clipboard</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
    </div>

    <div class="dialog-body">
        <CommunicationBar style="margin-top:20px;" expanded :contact="elementAsContact"/>
        <div style="margin:15px;display:flex">
            
            <div class="div-button display-flex clickable mr-2" @click="clickedEditContact">
                <v-icon class="mr-2" color="grey">account_circle</v-icon>
                <div>
                    <b class="grey--text text--darken-2">Edit {{firstName}}</b><br>
                    <span style="font-weight:350;color:#888">Name, phone, email for every future transaction</span>
                </div>
            </div>

            <div class="div-button display-flex clickable mr-2" @click="showElementDialog">
                <v-icon class="mr-2" color="grey">share</v-icon>
                <div>
                    <b class="grey--text text--darken-2">Change Association</b><br>
                    <span style="font-weight:350;color:#888">Role and comments for this transaction only</span>
                </div>
            </div>
        </div>
    </div>



    <div class="dialog-footer">
        <DeleteButton @delete="unlinkContact(elementAsContact)" style="float:left"></DeleteButton>
        <!-- <v-btn @click="showElementDialog" style="float:left" text icon><v-icon color="grey">filter_list</v-icon></v-btn> -->
        <v-btn @click="refreshContact" style="float:left" text icon><v-icon color="grey">refresh</v-icon></v-btn>

        <!-- <v-btn text @click.native="clickedEditContact">Edit Contact</v-btn> -->
        <v-btn text @click.native="clickedClose">Close</v-btn>
    </div>
    
</div>
     
</v-dialog> 

<!-- Dialogs -->
<ContactEditor :settings="contactEditor.settings" :contactItem="contactEditor.contact" @saved="contactSaved" />
<OfficeSelectionDialog :settings="officeSelectionDialog.settings" @select="copyToOffices"/>

</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
// 
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import StringHelpers from '../helpers/StringHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import CommunicationBar from '../ui-elements/CommunicationBar'
import ContactEditor from '../ui-elements/ContactEditor'
import DeleteButton from '../ui-elements/DeleteButton'
import ElementHelpers from '../helpers/ElementHelpers'
import OfficeSelectionDialog from '../ui-elements/OfficeSelectionDialog'
import AlertHelpers from '../helpers/AlertHelpers'
import clipboard from 'clipboard-js'
import NiceData from '../data/NiceData'


    var db = firebase.database()

    
    export default {
    props:{
        element: Object,
        transactionKey: String,
        settings: Object,
    },
    components: {
        CommunicationBar,
        ContactEditor,
        DeleteButton,
        OfficeSelectionDialog,
    },

    data() {
        return {

            dialogVisible: this.visible,
            contactEditor: {
                contact: null,
                settings: {
                    visible: false
                }
            },
            officeSelectionDialog: {
                settings: {
                    visible: false,
                }
            }
        }
    },
    computed: {
        dialogHeight() {
            if(this.$vuetify.breakpoint.smAndDown)
                return '100%'
            else
                return '500px'
        },
        title() {
            if(this.element && this.element.contact)
                return ContactHelpers.fullName(this.element.contact)
            else
                return 'Contact'
        },

        firstName() {
            if(this.element && this.element.contact)
                return this.element.contact.firstName
            else
                return 'Contact'
        },

        elementAsContact() {
            try {
                let newContact = {...this.element.contact}
                newContact.meta = {}
                newContact.meta.key = this.element.contactKey
                
                // Prevent original tenant key from inheriting when modifying masterfile contacts...
                newContact.meta.tenantKey = this.element.tenantKey != "1"
                    ? this.element.tenantKey
                    : NiceData.safelyGetTenant()
                    
                newContact.meta.role = this.element.role
                return newContact
            } catch (e) {
                console.log('elementAsContact fails')
                return {}
            }
        }
    },

    methods: {
        
        clickedClose () {
            this.settings.visible = false
            //this.$emit('close')
        },

        clickedEditContact () {
            this.settings.visible = false
            this.contactEditor.contact = this.elementAsContact
            this.contactEditor.settings.visible = true
        },

        unlinkContact() {
            this.settings.visible = false
            this.$emit('unlink', this.elementAsContact)
        },

        contactSaved () {
            this.refreshContact()
        }, 

        refreshContact() {
            this.$emit('refresh', this.element)
        },
        
        showElementDialog() {
            this.settings.visible = false
            this.$emit('edit-element', this.element)
        }, 
        showCopyToOffices() {
            this.officeSelectionDialog.settings.visible = true
        }, 
        copyToOffices(offices) {
            if(!offices || offices.length < 1)
                return
            let transactionContact = this.element
            offices.forEach(office => {
                ContactHelpers.copyTransactionContactToOffices(transactionContact, office.meta.key)
            })
            AlertHelpers.showAlert('Contact has been exported to other office/s')
        },
        clientToClipboard() {
                const str = ContactHelpers.contactDetailsToText(this.element.contact)
                
                clipboard.copy({'text': str})
                
                AlertHelpers.showAlert('Copied to clipboard')
        },



    },
    watch: {
        visible: function (newVal) {
            this.dialogVisible = newVal
            if(newVal) {
                
            }
                
        }
    },

    created () {

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// TransactionContact.vue?cac6ad9e